import { Component, OnInit, Input, SimpleChanges, ViewChild, Renderer2, AfterViewInit, Output, EventEmitter, ElementRef } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { SharedPoint, TimeSeriesDetail } from 'src/app/models/dashboard';
import { ElapsedTimeService } from '../../../service/elapsed-time.service';
import { SiteTwin } from 'src/api/models';

interface PreviousLightStackElement {
  key: string;
  element: Element;
}

@Component({
  selector: 'app-weather-station-viewer',
  templateUrl: './weather-station-viewer.component.html',
  styleUrls: ['./weather-station-viewer.component.css']
})
export class WeatherStationViewer implements OnInit, AfterViewInit {
  @ViewChild('imageSource') imageSource: ElementRef;
   
  @Input() siteTwin: SiteTwin;
  @Input() fullScreen: boolean = false;
  selectedImageKey: string;

  //selectedImage: SharedPoint[];
  
  constructor(private renderer:Renderer2, private elapsedTimeService:ElapsedTimeService) {
  }

  getSelectedImageOverlay(key){
    if (key == undefined){
      key = Object.keys(this.siteTwin.parameters)[0]
    }
    return this.siteTwin.parameters[key]?.analysis;
  }


  ngOnChanges(changes: SimpleChanges): void {
    
  }

  ngOnInit(): void {
    this.selectedImageKey = Object.keys(this.siteTwin.parameters)[0]
    console.log(this.siteTwin.parameters[this.selectedImageKey])
  }

  ngAfterViewInit() {
    
  }

  getBearings(){
    var images =  Object.keys(this.siteTwin.parameters).length;
    var bearings = [];
    var bearing = 0;
    var viewAngle = 180;
    var imageViewAngle = viewAngle / images; //todo: automate this calculation
    var viewAngleStepSize = imageViewAngle / 3;
    var start = bearing -(viewAngle / 2)
    var steps = images * 3;
    var startOffset = viewAngleStepSize / 2;
    for (let i = 0; i < steps; i++) {
      var b = i * viewAngleStepSize;
      b = start + b + startOffset;
      if (b < 0){
        b = b + 360;
      }
      bearings.push(b);
    }
    return bearings;
  }

  showImage(key){
    this.selectedImageKey = key;
  }
}
